import { endPointInvoice } from './base.config';

export const invoice = {
  getInvoicesByCompany: `${endPointInvoice}/invoices`,
};
